import React from 'react';

const Modal = (props) => {
	const { children, visible} = props

	return(
		<div>
			<div className="overlay"
				style={{
					backgroundColor: 'rgba(50,50,50,0.8)',
					width: '100vw',
					height: '100vh',
					position: 'fixed',
					visibility: (visible ? 'visible' : 'hidden'),
					top: 0,
					left: 0,
					zIndex: 300}}
					>
			</div>
			<div className="modal"
				style={{
					padding: '1em',
					boxShadow: '0px 0px 5px 1px #000',
					position: 'fixed',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					zIndex: 301,
					backgroundColor: '#fff',
					visibility: (visible ? 'visible' : 'hidden'),
					maxHeight: 'calc(100% - 100px)'
				}}>
			{children}
			</div>
		</div>
	)
}

export default Modal;


// WEBPACK FOOTER //
// ./src/ui/modal/Modal.js